import { createDesignActions } from './designActions';
import { createStackActions } from './stackActions';
import { createProductActions } from './productActions';
import { createUtilityActions } from './utilityActions';
import { removeNonVisualizedProduct } from './removeNonVisualizedProduct';
import { updateNonVisualizedQty } from './updateNonVisualizedQty';
import { addNonVisualizedProduct } from './addNonVisualizedProduct';
import { removeStackFromDesign } from './removeStackFromDesign';

export const createActions = (set, get) => ({
  ...createDesignActions(set, get),
  ...createStackActions(set, get),
  ...createProductActions(set, get),
  ...createUtilityActions(set, get),
  ...removeNonVisualizedProduct(set, get),
  ...updateNonVisualizedQty(set, get),
  ...addNonVisualizedProduct(set, get),
  ...removeStackFromDesign(set, get)
});
